// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"324":"5dd35fc0","385":"e818fb54","400":"d45c27e6","453":"64aababc","459":"9898f44f","494":"9255fd07","618":"ae613ce1","908":"4b427497"}[chunkId] + ".chunk.js";
};